// extracted by mini-css-extract-plugin
export default {"AddLink":"AddLink_AddLink__YxhRO"};